import { render, staticRenderFns } from "./ContentTop.vue?vue&type=template&id=63521408&scoped=true&"
import script from "./ContentTop.vue?vue&type=script&lang=js&"
export * from "./ContentTop.vue?vue&type=script&lang=js&"
import style0 from "./ContentTop.vue?vue&type=style&index=0&id=63521408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63521408",
  null
  
)

export default component.exports